import Column from '@components/Column';
import Row from '@components/Row';
import Skeleton from '@components/Skeleton';

import { cardCss } from './index';

interface Props {
    count?: number;
    /** 이벤트처럼 배너 이미지가 있는 카드 */
    withImage?: boolean;
}

function BoardCardSkeletons({ count = 3, withImage = false }: Props) {
    return (
        <Column fullWidth spacing={4} aria-busy>
            {Array.from({ length: count }).map((_, idx) => (
                <div css={cardCss} key={`board-card-sk-${idx}`}>
                    <Row spacing={2}>
                        {withImage && <Skeleton width={40} height={22} />}
                        <Skeleton width={withImage ? 140 : 72} height={17} />
                    </Row>
                    <Skeleton width='60%' height={22} />
                    {withImage && <Skeleton height={172} />}
                    <Skeleton height={20} />
                </div>
            ))}
        </Column>
    );
}

export default BoardCardSkeletons;
